import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorGlobal, successGlobal } from '../reducers/notifications';
import { updateUnit } from '../reducers/packagingUnit';
import { getAuthHeader } from '../../utils/tools';
import axios from 'axios';

export const fetchPackagingUnitDocuments = createAsyncThunk(
    'packagingUnitDocument/fetch',
    async (packagingUnitId, { dispatch }) => {
        try {
            const res = await axios.get('/api/packagingunitdocument/fetch', {
                params: { packagingUnitId },
                ...getAuthHeader(),
            });
            return res.data;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message ?? 'Dokumenty sa nepodarilo načítať.'));
            throw error;
        }
    }
);

export const uploadPackagingUnitDocuments = createAsyncThunk(
    'packagingUnitDocument/upload',
    async ({ files, packagingUnitId, componentId, componentName, checklistItemId, checklistItemLabel }, { dispatch }) => {
        try {
            const formData = new FormData();
            files.forEach(file => formData.append('files', file));
            formData.append('packagingUnitId', packagingUnitId);
            if (componentId) formData.append('componentId', componentId);
            if (componentName) formData.append('componentName', componentName);
            if (checklistItemId) formData.append('checklistItemId', checklistItemId);
            if (checklistItemLabel) formData.append('checklistItemLabel', checklistItemLabel);
            const res = await axios.post('/api/packagingunitdocument/upload', formData, getAuthHeader());
            dispatch(successGlobal(`Nahraných ${files.length === 1 ? '1 súbor' : `${files.length} súborov`}.`));
            if (res.data.unit) dispatch(updateUnit(res.data.unit));
            return res.data.documents;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message ?? 'Nahrávanie sa nepodarilo.'));
            throw error;
        }
    }
);

export const deletePackagingUnitDocument = createAsyncThunk(
    'packagingUnitDocument/delete',
    async ({ documentId, packagingUnitId }, { dispatch }) => {
        try {
            const res = await axios.delete('/api/packagingunitdocument/delete', {
                data: { documentId, packagingUnitId },
                ...getAuthHeader(),
            });
            dispatch(successGlobal('Dokument bol vymazaný.'));
            if (res.data.unit) dispatch(updateUnit(res.data.unit));
            return res.data.documents;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message ?? 'Dokument sa nepodarilo vymazať.'));
            throw error;
        }
    }
);

export const downloadPackagingUnitDocument = createAsyncThunk(
    'packagingUnitDocument/download',
    async ({ documentId, packagingUnitId, originalName }, { dispatch }) => {
        try {
            const res = await axios.get('/api/packagingunitdocument/download', {
                params: { documentId, packagingUnitId },
                responseType: 'blob',
                ...getAuthHeader(),
            });
            const url = URL.createObjectURL(res.data);
            const a = document.createElement('a');
            a.href = url;
            a.download = originalName;
            a.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            dispatch(errorGlobal('Stiahnutie sa nepodarilo.'));
            throw error;
        }
    }
);
